import YthOptions from './site-assets/options';
import YthHeading from './site-assets/headings';
import YthKeyword from './site-assets/keywords';
import YthUsers from './site-assets/users';
import YthBusiness from './site-assets/business';
import TrsutedLocalApi from './site-assets/trusted-local-api';
// import YthSearchPlaces from './site-assets/search-places';
import dropzone from './site-assets/dropzone';
import action from './site-assets/action';
import subscription from './site-assets/subscription';
import publisherPage from './site-assets/publisherPage';

var _token = $('meta[name="csrf-token"]').attr('content');
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': _token
  }
});

const YthApp = (() => {
  // YthSearchPlaces();
  YthBusiness();
  YthUsers();
  YthOptions();
  YthHeading();
  YthKeyword();
  TrsutedLocalApi();
  dropzone();
  action();
  subscription();
  publisherPage();
});
YthApp();
